import { Box, Typography } from '@qbe/ads-core';
import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { COVER_DETAILS_PORTABLE_ITEMS_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { Cover } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

const ReviewPortableItems: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.portableItems' });

  const { blanketCovers, specifiedItems, totalCoverValue } = useCoverDetails();

  const blanketCoverReviewList = blanketCovers?.map((b) => ({
    label: b.category,
    data: currencyFormatter(b.value, CurrencyFormat.Comma),
  }));

  const specifiedItemsReviewList = specifiedItems?.map((s) => ({
    label: s.description || '',
    data: currencyFormatter(s.value, CurrencyFormat.Comma),
  }));

  const portableItemsReviewList = [
    {
      category: getTextContent('blanketCover'),
    },
    ...(blanketCoverReviewList && blanketCoverReviewList.length > 0
      ? blanketCoverReviewList
      : [{ label: getTextContent('noItems'), data: '' }]),
    {
      category: getTextContent('specifiedItems'),
    },
    ...(specifiedItemsReviewList && specifiedItemsReviewList.length > 0
      ? specifiedItemsReviewList
      : [{ label: getTextContent('noItems'), data: '' }]),
  ];

  return (
    <>
      <ReviewList
        list={
          portableItemsReviewList.reduce((prev, curr, idx) => {
            let list;
            if ('category' in curr && curr.category) {
              list = {
                id: idx,
                name: curr.category,
                label: curr.category,
                value: curr.category,
              };
            } else if ('label' in curr) {
              list = {
                id: idx,
                name: curr.label,
                label: curr.label,
                value: curr.data,
              };
            }
            return {
              ...prev,
              [String(idx)]: list,
            };
          }, {}) as ListType
        }
        title={Cover.PortableItems}
        editRoute={COVER_DETAILS_PORTABLE_ITEMS_ROUTE}
      />
      <Box display="flex" justifyContent="space-between" width="100%" color="#003DA5">
        <Typography>{getTextContent('totalValue')}</Typography>
        <Typography fontWeight="fontWeightBold">
          {currencyFormatter(totalCoverValue, CurrencyFormat.Comma)}
        </Typography>
      </Box>
    </>
  );
};

export default ReviewPortableItems;
